var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconSingleNeutralBook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 23.25H5.25A2.25 2.25 0 0 1 3 21M6 .75a3 3 0 0 0-3 3V21a2.25 2.25 0 0 1 2.25-2.25H19.5a1.5 1.5 0 0 0 1.5-1.5v-15a1.5 1.5 0 0 0-1.5-1.5Zm13.5 22.5v-4.5",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 7.875a2.625 2.625 0 1 0 5.25 0 2.625 2.625 0 1 0-5.25 0ZM7.5 15.75a4.5 4.5 0 0 1 9 0",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconSingleNeutralBook);
export default __webpack_public_path__ + "static/media/streamline-icon-single-neutral-book.837cfbfd.svg";
export { ForwardRef as ReactComponent };